export default {
    matchInfo: {
        id: '7c2f1r3fe7code6ijoi1xzh1w',
        coverageLevel: '15',
        date: '2022-08-28Z',
        time: '15:30:00Z',
        localDate: '2022-08-28',
        localTime: '16:30:00',
        week: '4',
        numberOfPeriods: 2,
        periodLength: 45,
        lastUpdated: '2022-08-28T16:18:47Z',
        description: 'Nottingham Forest vs Tottenham Hotspur',
        sport: {
            id: '289u5typ3vp4ifwh5thalohmq',
            name: 'Soccer',
        },
        ruleset: {
            id: '79plas4983031idr6vw83nuel',
            name: 'Men',
        },
        competition: {
            id: '2kwbbcootiqqgmrzs6o5inle5',
            name: 'Premier League',
            competitionCode: 'EPL',
            competitionFormat: 'Domestic league',
            country: {
                id: '1fk5l4hkqk12i7zske6mcqju6',
                name: 'England',
            },
        },
        tournamentCalendar: {
            id: '80foo89mm28qjvyhjzlpwj28k',
            startDate: '2022-08-05Z',
            endDate: '2023-05-28Z',
            name: '2022/2023',
        },
        stage: {
            id: '80qbeanalyj5cvxikkq351iqc',
            formatId: 'e2q01r9o9jwiq1fls93d1sslx',
            startDate: '2022-08-05Z',
            endDate: '2023-05-28Z',
            name: 'Regular Season',
        },
        contestant: [
            {
                id: '1qtaiy11gswx327s0vkibf70n',
                name: 'Nottingham Forest',
                shortName: 'Nottm Forest',
                officialName: 'Nottingham Forest FC',
                code: 'NFO',
                position: 'home',
                country: {
                    id: '1fk5l4hkqk12i7zske6mcqju6',
                    name: 'England',
                },
            },
            {
                id: '22doj4sgsocqpxw45h607udje',
                name: 'Tottenham Hotspur',
                shortName: 'Tottenham',
                officialName: 'Tottenham Hotspur FC',
                code: 'TOT',
                position: 'away',
                country: {
                    id: '1fk5l4hkqk12i7zske6mcqju6',
                    name: 'England',
                },
            },
        ],
        venue: {
            id: '6ccyj8bk3iv2mc01xe5rtch3r',
            neutral: 'no',
            longName: 'The City Ground',
            shortName: 'The City Ground',
        },
    },
    liveData: {
        matchDetails: {
            periodId: 10,
            matchStatus: 'Playing',
            period: [
                {
                    id: 1,
                    start: '2022-08-28T15:30:17Z',
                    end: '2022-08-28T16:16:23Z',
                    lengthMin: 46,
                    lengthSec: 6,
                },
            ],
            scores: {
                ht: {
                    home: 0,
                    away: 1,
                },
                ft: {
                    home: 0,
                    away: 1,
                },
                total: {
                    home: 0,
                    away: 1,
                },
            },
        },
        goal: [
            {
                contestantId: '22doj4sgsocqpxw45h607udje',
                periodId: 1,
                timeMin: 5,
                timeMinSec: '4:58',
                lastUpdated: '2022-08-28T15:36:23Z',
                timestamp: '2022-08-28T15:35:15Z',
                type: 'G',
                scorerId: 'b9g4qurpll4wizajo95c406hh',
                scorerName: 'H. Kane',
                assistPlayerId: 'dlf31m2lrfl0biop1demgvh7t',
                assistPlayerName: 'D. Kulusevski',
                optaEventId: '2452502131',
                homeScore: 0,
                awayScore: 1,
            },
        ],
        lineUp: [
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                formationUsed: '3421',
                teamOfficial: {
                    id: '7qb4jzx7wrt2syeio63jpjtgp',
                    firstName: 'Steven David',
                    lastName: 'Cooper',
                    type: 'manager',
                },
                stat: [
                    {
                        fh: '2',
                        type: 'cornerTaken',
                        value: '2',
                    },
                    {
                        fh: '1',
                        type: 'lastManTackle',
                        value: '1',
                    },
                    {
                        fh: '5',
                        type: 'putThrough',
                        value: '5',
                    },
                    {
                        fh: '3',
                        type: 'goalKicks',
                        value: '3',
                    },
                    {
                        fh: '1',
                        type: 'totalKeeperSweeper',
                        value: '1',
                    },
                    {
                        fh: '412',
                        type: 'touches',
                        value: '412',
                    },
                    {
                        fh: '10',
                        type: 'accurateChippedPass',
                        value: '10',
                    },
                    {
                        fh: '2',
                        type: 'attLfTotal',
                        value: '2',
                    },
                    {
                        fh: '6',
                        type: 'totalAttAssist',
                        value: '6',
                    },
                    {
                        fh: '7',
                        type: 'aerialWon',
                        value: '7',
                    },
                    {
                        fh: '2',
                        type: 'crosses18yardplus',
                        value: '2',
                    },
                    {
                        fh: '92',
                        type: 'successfulFinalThirdPasses',
                        value: '92',
                    },
                    {
                        fh: '10',
                        type: 'totalTackle',
                        value: '10',
                    },
                    {
                        fh: '4',
                        type: 'attOboxBlocked',
                        value: '4',
                    },
                    {
                        fh: '2',
                        type: 'accurateLayoffs',
                        value: '2',
                    },
                    {
                        fh: '43',
                        type: 'finalThirdEntries',
                        value: '43',
                    },
                    {
                        fh: '7',
                        type: 'totalLaunches',
                        value: '7',
                    },
                    {
                        fh: '2',
                        type: 'totalLayoffs',
                        value: '2',
                    },
                    {
                        fh: '1',
                        type: 'outfielderBlock',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'attMissLeft',
                        value: '1',
                    },
                    {
                        fh: '276',
                        type: 'accuratePass',
                        value: '276',
                    },
                    {
                        fh: '1',
                        type: 'attCmissLeft',
                        value: '1',
                    },
                    {
                        fh: '2',
                        type: 'fkFoulLost',
                        value: '2',
                    },
                    {
                        fh: '9',
                        type: 'totalScoringAtt',
                        value: '9',
                    },
                    {
                        fh: '3',
                        type: 'ontargetAttAssist',
                        value: '3',
                    },
                    {
                        fh: '8',
                        type: 'attOpenplay',
                        value: '8',
                    },
                    {
                        fh: '5',
                        type: 'interceptionWon',
                        value: '5',
                    },
                    {
                        fh: '4',
                        type: 'shotOffTarget',
                        value: '4',
                    },
                    {
                        fh: '1',
                        type: 'accurateGoalKicks',
                        value: '1',
                    },
                    {
                        fh: '88',
                        type: 'fwdPass',
                        value: '88',
                    },
                    {
                        fh: '1',
                        type: 'attCorner',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'ontargetScoringAtt',
                        value: '1',
                    },
                    {
                        fh: '8',
                        type: 'unsuccessfulTouch',
                        value: '8',
                    },
                    {
                        fh: '81',
                        type: 'possLostCtrl',
                        value: '81',
                    },
                    {
                        fh: '13',
                        type: 'totalCross',
                        value: '13',
                    },
                    {
                        fh: '320',
                        type: 'openPlayPass',
                        value: '320',
                    },
                    {
                        fh: '1',
                        type: 'attemptsConcededIbox',
                        value: '1',
                    },
                    {
                        fh: '4',
                        type: 'effectiveClearance',
                        value: '4',
                    },
                    {
                        fh: '6',
                        type: 'attRfTotal',
                        value: '6',
                    },
                    {
                        fh: '329',
                        type: 'totalPass',
                        value: '329',
                    },
                    {
                        fh: '2',
                        type: 'attMissHigh',
                        value: '2',
                    },
                    {
                        fh: '3',
                        type: 'fkFoulWon',
                        value: '3',
                    },
                    {
                        fh: '1',
                        type: 'attOboxMiss',
                        value: '1',
                    },
                    {
                        fh: '234',
                        type: 'totalFwdZonePass',
                        value: '234',
                    },
                    {
                        fh: '1',
                        type: 'accurateCross',
                        value: '1',
                    },
                    {
                        fh: '2',
                        type: 'wonCorners',
                        value: '2',
                    },
                    {
                        fh: '1',
                        type: 'goalsConcededObox',
                        value: '1',
                    },
                    {
                        fh: '108',
                        type: 'totalBackZonePass',
                        value: '108',
                    },
                    {
                        fh: '4',
                        type: 'totalClearance',
                        value: '4',
                    },
                    {
                        fh: '1',
                        type: 'attMissRight',
                        value: '1',
                    },
                    {
                        fh: '2',
                        type: 'effectiveHeadClearance',
                        value: '2',
                    },
                    {
                        fh: '47',
                        type: 'backwardPass',
                        value: '47',
                    },
                    {
                        fh: '24',
                        type: 'longPassOwnToOppSuccess',
                        value: '24',
                    },
                    {
                        fh: '1',
                        type: 'goalsConceded',
                        value: '1',
                    },
                    {
                        fh: '8',
                        type: 'crosses18yard',
                        value: '8',
                    },
                    {
                        fh: '2',
                        type: 'totalCornersIntobox',
                        value: '2',
                    },
                    {
                        fh: '173',
                        type: 'accurateFwdZonePass',
                        value: '173',
                    },
                    {
                        fh: '8',
                        type: 'aerialLost',
                        value: '8',
                    },
                    {
                        fh: '33',
                        type: 'totalLongBalls',
                        value: '33',
                    },
                    {
                        fh: '1',
                        type: 'attOboxTarget',
                        value: '1',
                    },
                    {
                        fh: '81',
                        type: 'possLostAll',
                        value: '81',
                    },
                    {
                        fh: '89',
                        type: 'rightsidePass',
                        value: '89',
                    },
                    {
                        fh: '126',
                        type: 'totalFinalThirdPasses',
                        value: '126',
                    },
                    {
                        fh: '6',
                        type: 'attObxCentre',
                        value: '6',
                    },
                    {
                        fh: '1',
                        type: 'attLfTarget',
                        value: '1',
                    },
                    {
                        fh: '3',
                        type: 'offtargetAttAssist',
                        value: '3',
                    },
                    {
                        fh: '11',
                        type: 'accurateThrows',
                        value: '11',
                    },
                    {
                        fh: '25',
                        type: 'penAreaEntries',
                        value: '25',
                    },
                    {
                        fh: '6',
                        type: 'totalContest',
                        value: '6',
                    },
                    {
                        fh: '5',
                        type: 'blockedPass',
                        value: '5',
                    },
                    {
                        fh: '9',
                        type: 'possWonAtt3rd',
                        value: '9',
                    },
                    {
                        fh: '16',
                        type: 'possWonMid3rd',
                        value: '16',
                    },
                    {
                        fh: '2',
                        type: 'headClearance',
                        value: '2',
                    },
                    {
                        fh: '1',
                        type: 'dispossessed',
                        value: '1',
                    },
                    {
                        fh: '6',
                        type: 'attemptsObox',
                        value: '6',
                    },
                    {
                        fh: '3',
                        type: 'attIboxMiss',
                        value: '3',
                    },
                    {
                        fh: '270',
                        type: 'successfulOpenPlayPass',
                        value: '270',
                    },
                    {
                        fh: '6',
                        type: 'attAssistOpenplay',
                        value: '6',
                    },
                    {
                        fh: '9',
                        type: 'possWonDef3rd',
                        value: '9',
                    },
                    {
                        fh: '2',
                        type: 'challengeLost',
                        value: '2',
                    },
                    {
                        fh: '14',
                        type: 'accurateLongBalls',
                        value: '14',
                    },
                    {
                        fh: '58.8',
                        type: 'possessionPercentage',
                        value: '58.8',
                    },
                    {
                        fh: '34',
                        type: 'ballRecovery',
                        value: '34',
                    },
                    {
                        fh: '105',
                        type: 'leftsidePass',
                        value: '105',
                    },
                    {
                        fh: '4',
                        type: 'blockedScoringAtt',
                        value: '4',
                    },
                    {
                        fh: '1',
                        type: 'freekickCross',
                        value: '1',
                    },
                    {
                        fh: '43',
                        type: 'longPassOwnToOpp',
                        value: '43',
                    },
                    {
                        fh: '5',
                        type: 'wonTackle',
                        value: '5',
                    },
                    {
                        fh: '21',
                        type: 'totalChippedPass',
                        value: '21',
                    },
                    {
                        fh: '4',
                        type: 'successfulPutThrough',
                        value: '4',
                    },
                    {
                        fh: '1',
                        type: 'attBxRight',
                        value: '1',
                    },
                    {
                        fh: '2',
                        type: 'fouledFinalThird',
                        value: '2',
                    },
                    {
                        fh: '1',
                        type: 'accurateCrossNocorner',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'accurateKeeperSweeper',
                        value: '1',
                    },
                    {
                        fh: '12',
                        type: 'totalThrows',
                        value: '12',
                    },
                    {
                        fh: '54',
                        type: 'passesLeft',
                        value: '54',
                    },
                    {
                        fh: '1',
                        type: 'attSvLowCentre',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'attHdTotal',
                        value: '1',
                    },
                    {
                        fh: '5',
                        type: 'interception',
                        value: '5',
                    },
                    {
                        fh: '1',
                        type: 'handBall',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'totalOffside',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'wonContest',
                        value: '1',
                    },
                    {
                        fh: '17',
                        type: 'duelLost',
                        value: '17',
                    },
                    {
                        fh: '2',
                        type: 'attBxCentre',
                        value: '2',
                    },
                    {
                        fh: '11',
                        type: 'totalCrossNocorner',
                        value: '11',
                    },
                    {
                        fh: '43',
                        type: 'passesRight',
                        value: '43',
                    },
                    {
                        fh: '21',
                        type: 'duelWon',
                        value: '21',
                    },
                    {
                        fh: '21',
                        type: 'touchesInOppBox',
                        value: '21',
                    },
                    {
                        fh: '104',
                        type: 'accurateBackZonePass',
                        value: '104',
                    },
                    {
                        fh: '3',
                        type: 'attemptsIbox',
                        value: '3',
                    },
                    {
                        fh: '4',
                        type: 'attemptsConcededObox',
                        value: '4',
                    },
                    {
                        fh: '1',
                        type: 'attHdMiss',
                        value: '1',
                    },
                    {
                        type: 'formationUsed',
                        value: '3421',
                    },
                ],
                kit: {
                    id: '4782',
                    colour1: '#FF0000',
                    colour2: '#FFFFFF',
                    type: 'home',
                },
            },
            {
                contestantId: '22doj4sgsocqpxw45h607udje',
                formationUsed: '3421',
                teamOfficial: {
                    id: '2t14kex330qljt5vlmssvo6ad',
                    firstName: 'Antonio',
                    lastName: 'Conte Cavaliere',
                    type: 'manager',
                },
                stat: [
                    {
                        fh: '7',
                        type: 'headClearance',
                        value: '7',
                    },
                    {
                        fh: '7',
                        type: 'dispossessed',
                        value: '7',
                    },
                    {
                        fh: '4',
                        type: 'attemptsObox',
                        value: '4',
                    },
                    {
                        fh: '2',
                        type: 'attAssistOpenplay',
                        value: '2',
                    },
                    {
                        fh: '1',
                        type: 'attIboxMiss',
                        value: '1',
                    },
                    {
                        fh: '178',
                        type: 'successfulOpenPlayPass',
                        value: '178',
                    },
                    {
                        fh: '5',
                        type: 'totalContest',
                        value: '5',
                    },
                    {
                        fh: '5',
                        type: 'blockedPass',
                        value: '5',
                    },
                    {
                        fh: '7',
                        type: 'possWonMid3rd',
                        value: '7',
                    },
                    {
                        fh: '1',
                        type: 'possWonAtt3rd',
                        value: '1',
                    },
                    {
                        fh: '65',
                        type: 'leftsidePass',
                        value: '65',
                    },
                    {
                        fh: '36',
                        type: 'ballRecovery',
                        value: '36',
                    },
                    {
                        fh: '1',
                        type: 'blockedScoringAtt',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'totalFlickOn',
                        value: '1',
                    },
                    {
                        fh: '2',
                        type: 'accurateKeeperThrows',
                        value: '2',
                    },
                    {
                        fh: '1',
                        type: 'challengeLost',
                        value: '1',
                    },
                    {
                        fh: '24',
                        type: 'possWonDef3rd',
                        value: '24',
                    },
                    {
                        fh: '9',
                        type: 'accurateLongBalls',
                        value: '9',
                    },
                    {
                        fh: '41.2',
                        type: 'possessionPercentage',
                        value: '41.2',
                    },
                    {
                        fh: '1',
                        type: 'attGoalLowLeft',
                        value: '1',
                    },
                    {
                        fh: '69',
                        type: 'possLostAll',
                        value: '69',
                    },
                    {
                        fh: '34',
                        type: 'totalFinalThirdPasses',
                        value: '34',
                    },
                    {
                        fh: '55',
                        type: 'rightsidePass',
                        value: '55',
                    },
                    {
                        fh: '4',
                        type: 'attObxCentre',
                        value: '4',
                    },
                    {
                        fh: '49',
                        type: 'accurateFwdZonePass',
                        value: '49',
                    },
                    {
                        fh: '1',
                        type: 'attFastbreak',
                        value: '1',
                    },
                    {
                        fh: '25',
                        type: 'totalLongBalls',
                        value: '25',
                    },
                    {
                        fh: '7',
                        type: 'aerialLost',
                        value: '7',
                    },
                    {
                        fh: '1',
                        type: 'attOboxGoal',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'offtargetAttAssist',
                        value: '1',
                    },
                    {
                        fh: '7',
                        type: 'accurateThrows',
                        value: '7',
                    },
                    {
                        fh: '3',
                        type: 'penAreaEntries',
                        value: '3',
                    },
                    {
                        fh: '1',
                        type: 'attCmissRight',
                        value: '1',
                    },
                    {
                        fh: '11',
                        type: 'interception',
                        value: '11',
                    },
                    {
                        fh: '1',
                        type: 'handBall',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'totalOffside',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'attRfGoal',
                        value: '1',
                    },
                    {
                        fh: '2',
                        type: 'wonContest',
                        value: '2',
                    },
                    {
                        fh: '1',
                        type: 'forwardGoals',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'divingSave',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'goalAssistOpenplay',
                        value: '1',
                    },
                    {
                        fh: '7',
                        type: 'totalThrows',
                        value: '7',
                    },
                    {
                        fh: '10',
                        type: 'passesLeft',
                        value: '10',
                    },
                    {
                        fh: '1',
                        type: 'attemptsIbox',
                        value: '1',
                    },
                    {
                        fh: '137',
                        type: 'accurateBackZonePass',
                        value: '137',
                    },
                    {
                        fh: '8',
                        type: 'touchesInOppBox',
                        value: '8',
                    },
                    {
                        fh: '6',
                        type: 'attemptsConcededObox',
                        value: '6',
                    },
                    {
                        fh: '21',
                        type: 'duelLost',
                        value: '21',
                    },
                    {
                        fh: '16',
                        type: 'passesRight',
                        value: '16',
                    },
                    {
                        fh: '17',
                        type: 'duelWon',
                        value: '17',
                    },
                    {
                        fh: '4',
                        type: 'totalCrossNocorner',
                        value: '4',
                    },
                    {
                        fh: '3',
                        type: 'wonTackle',
                        value: '3',
                    },
                    {
                        fh: '17',
                        type: 'totalChippedPass',
                        value: '17',
                    },
                    {
                        fh: '1',
                        type: 'successfulPutThrough',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'attBxLeft',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'savedObox',
                        value: '1',
                    },
                    {
                        fh: '26',
                        type: 'longPassOwnToOpp',
                        value: '26',
                    },
                    {
                        fh: '1',
                        type: 'goalsOpenplay',
                        value: '1',
                    },
                    {
                        fh: '2',
                        type: 'accurateCrossNocorner',
                        value: '2',
                    },
                    {
                        fh: '1',
                        type: 'shotFastbreak',
                        value: '1',
                    },
                    {
                        fh: '2',
                        type: 'interceptionsInBox',
                        value: '2',
                    },
                    {
                        fh: '12',
                        type: 'finalThirdEntries',
                        value: '12',
                    },
                    {
                        fh: '4',
                        type: 'totalLaunches',
                        value: '4',
                    },
                    {
                        fh: '6',
                        type: 'accurateChippedPass',
                        value: '6',
                    },
                    {
                        fh: '3',
                        type: 'totalAttAssist',
                        value: '3',
                    },
                    {
                        fh: '1',
                        type: 'attLfTotal',
                        value: '1',
                    },
                    {
                        fh: '8',
                        type: 'aerialWon',
                        value: '8',
                    },
                    {
                        fh: '23',
                        type: 'successfulFinalThirdPasses',
                        value: '23',
                    },
                    {
                        fh: '6',
                        type: 'totalTackle',
                        value: '6',
                    },
                    {
                        fh: '1',
                        type: 'attOboxBlocked',
                        value: '1',
                    },
                    {
                        fh: '2',
                        type: 'crosses18yardplus',
                        value: '2',
                    },
                    {
                        fh: '4',
                        type: 'fkFoulLost',
                        value: '4',
                    },
                    {
                        fh: '1',
                        type: 'goals',
                        value: '1',
                    },
                    {
                        fh: '5',
                        type: 'totalScoringAtt',
                        value: '5',
                    },
                    {
                        fh: '2',
                        type: 'ontargetAttAssist',
                        value: '2',
                    },
                    {
                        fh: '5',
                        type: 'attOpenplay',
                        value: '5',
                    },
                    {
                        fh: '1',
                        type: 'totalFastbreak',
                        value: '1',
                    },
                    {
                        fh: '4',
                        type: 'outfielderBlock',
                        value: '4',
                    },
                    {
                        fh: '184',
                        type: 'accuratePass',
                        value: '184',
                    },
                    {
                        fh: '4',
                        type: 'keeperThrows',
                        value: '4',
                    },
                    {
                        fh: '5',
                        type: 'putThrough',
                        value: '5',
                    },
                    {
                        fh: '1',
                        type: 'attCmissHigh',
                        value: '1',
                    },
                    {
                        type: 'firstHalfGoals',
                        value: '1',
                    },
                    {
                        fh: '2',
                        type: 'attemptedTackleFoul',
                        value: '2',
                    },
                    {
                        fh: '5',
                        type: 'goalKicks',
                        value: '5',
                    },
                    {
                        fh: '324',
                        type: 'touches',
                        value: '324',
                    },
                    {
                        fh: '1',
                        type: 'punches',
                        value: '1',
                    },
                    {
                        fh: '70',
                        type: 'totalFwdZonePass',
                        value: '70',
                    },
                    {
                        fh: '2',
                        type: 'attOboxMiss',
                        value: '2',
                    },
                    {
                        fh: '2',
                        type: 'accurateCross',
                        value: '2',
                    },
                    {
                        fh: '1',
                        type: 'attMissHigh',
                        value: '1',
                    },
                    {
                        fh: '1',
                        type: 'fkFoulWon',
                        value: '1',
                    },
                    {
                        fh: '2',
                        type: 'crosses18yard',
                        value: '2',
                    },
                    {
                        fh: '166',
                        type: 'totalBackZonePass',
                        value: '166',
                    },
                    {
                        fh: '16',
                        type: 'totalClearance',
                        value: '16',
                    },
                    {
                        fh: '2',
                        type: 'attMissRight',
                        value: '2',
                    },
                    {
                        fh: '2',
                        type: 'lostCorners',
                        value: '2',
                    },
                    {
                        fh: '16',
                        type: 'longPassOwnToOppSuccess',
                        value: '16',
                    },
                    {
                        fh: '7',
                        type: 'effectiveHeadClearance',
                        value: '7',
                    },
                    {
                        fh: '33',
                        type: 'backwardPass',
                        value: '33',
                    },
                    {
                        fh: '69',
                        type: 'possLostCtrl',
                        value: '69',
                    },
                    {
                        fh: '6',
                        type: 'unsuccessfulTouch',
                        value: '6',
                    },
                    {
                        fh: '4',
                        type: 'totalCross',
                        value: '4',
                    },
                    {
                        fh: '1',
                        type: 'saves',
                        value: '1',
                    },
                    {
                        fh: '224',
                        type: 'openPlayPass',
                        value: '224',
                    },
                    {
                        fh: '11',
                        type: 'interceptionWon',
                        value: '11',
                    },
                    {
                        fh: '3',
                        type: 'shotOffTarget',
                        value: '3',
                    },
                    {
                        fh: '1',
                        type: 'goalAssist',
                        value: '1',
                    },
                    {
                        fh: '3',
                        type: 'accurateGoalKicks',
                        value: '3',
                    },
                    {
                        fh: '79',
                        type: 'fwdPass',
                        value: '79',
                    },
                    {
                        fh: '1',
                        type: 'ontargetScoringAtt',
                        value: '1',
                    },
                    {
                        fh: '3',
                        type: 'attemptsConcededIbox',
                        value: '3',
                    },
                    {
                        fh: '4',
                        type: 'attRfTotal',
                        value: '4',
                    },
                    {
                        fh: '16',
                        type: 'effectiveClearance',
                        value: '16',
                    },
                    {
                        fh: '232',
                        type: 'totalPass',
                        value: '232',
                    },
                    {
                        type: 'formationUsed',
                        value: '3421',
                    },
                ],
                kit: {
                    id: '4',
                    colour1: '#FFFFFF',
                    colour2: '#132257',
                    type: 'home',
                },
            },
        ],
        matchDetailsExtra: {
            matchOfficial: [
                {
                    id: '3oe7osb8o3cy0dgex37asng0l',
                    type: 'Main',
                    firstName: 'Craig',
                    lastName: 'Pawson',
                },
                {
                    id: 'f1g3337l5j65736o54oswmxud',
                    type: 'Lineman 1',
                    firstName: 'Ian',
                    lastName: 'Hussin',
                },
                {
                    id: '9fqj6o3vtcziwj0xpzy4e6j85',
                    type: 'Lineman 2',
                    firstName: 'Scott',
                    lastName: 'Ledger',
                },
                {
                    id: '6l3ie5htdymg13u2ui69wo251',
                    type: 'Fourth official',
                    firstName: 'Darren',
                    lastName: 'England',
                },
            ],
        },
    },
}
